import { SHELL, Btn, Mono } from "@/components/bits";

export default function NotFound() {
    return (
        <section className="min-h-[70vh] flex items-center pt-24">
            <SHELL className="text-center">
                <Mono className="text-vera-gold">ERROR 404</Mono>
                <h1 className="text-4xl sm:text-5xl font-black tracking-tight mt-6 mb-4">This layer does not exist.</h1>
                <p className="text-vera-mut text-sm mb-10">The page you requested is not part of the VERA infrastructure.</p>
                <Btn variant="blue" to="/" testid="notfound-home-link">BACK TO VERA</Btn>
            </SHELL>
        </section>
    );
}
